// apps/embed/config/mui-compiled-out/styles/createThemeWithVars.js
//
// Stands in for @mui/material/esm/styles/createThemeWithVars.js in the embed's build (config/stand-ins.cjs).
// MUI's createTheme calls it only for a theme with `cssVariables` or `colorSchemes`, and no widget creates one:
// createStorefrontTheme, createHeaderTheme, createWidgetTheme and DefaultThemeWrapper build plain themes. The same
// exports as the real file; each throws, so a CSS-variables theme fails at once instead of rendering wrong.
function compiledOut() {
	throw new Error("MUI's CSS-variables themes (cssVariables, colorSchemes, extendTheme) are compiled out of the embed: apps/embed/config/stand-ins.cjs");
}

export const createGetCssVar = compiledOut;
export default compiledOut;
